export const legal_fr_Translation = {
  terms_and_conditions: {
    title: "Conditions Générales",
    intro:
      "Ce Contrat de Licence Utilisateur Final est un accord valide entre Vous et la Société. Veuillez lire attentivement ce CLUF. Les règles du CLUF vous engagent. Si vous ne souhaitez pas être lié par les règles du CLUF, veuillez ne pas utiliser le WebApp. Si vous continuez à utiliser le WebApp, cela signifiera que vous avez lu et compris le CLUF et que vous acceptez d'y être lié.",
    definitions: {
      title: "1. DÉFINITIONS ET TERMES",
      description:
        "Pour comprendre clairement les règles du CLUF, vous devez vous familiariser avec la signification des termes utilisés dans le CLUF. Dans ce CLUF, les termes suivants, lorsqu'ils sont en majuscules, auront les significations suivantes :",
      definitions_list: {
        account:
          "« Compte » – signifie un compte personnel d'un utilisateur des services de la Plateforme, fourni par l'Administrateur de la Plateforme conformément aux Conditions d'utilisation de la Plateforme ou à un document similaire. Le Compte est accessible avec un ID de Plateforme (nom de compte) et un mot de passe.",
        company:
          "« Société », « Nous » – signifie WEBFY, une société constituée en Irlande à l'adresse suivante : Black Church. St Mary’s Place. Dublin D07 P4AX. Irlande.",
        content:
          "« Contenu » – signifie tous les types de contenu, y compris, entre autres, les données, les textes, les images, les vidéos, les sons, les liens, les logiciels et autres informations sous toute forme, mises à votre disposition via le WebApp.",
        device:
          "« Appareil » – signifie un smartphone, une tablette ou tout autre dispositif mobile similaire que vous possédez ou contrôlez légalement exclusivement pour votre usage personnel non commercial.",
        eula: "« CLUF » – signifie ce Contrat de Licence Utilisateur Final, qui est un accord contraignant entre vous et la Société. Le CLUF peut incorporer d'autres documents, tels que la Politique de Confidentialité qui régit les relations entre vous et nous concernant l'utilisation du WebApp. Si un document fait partie du CLUF, il en aura une indication claire.",
        intellectual_property_rights:
          "« Droits de Propriété Intellectuelle » – désigne, collectivement, les droits en vertu de toute loi sur les brevets, les marques de commerce, le droit d'auteur et les secrets commerciaux, ainsi que tout autre droit de propriété intellectuelle ou exclusif reconnu dans tout pays ou juridiction dans le monde entier, y compris, sans limitation, les droits moraux ou similaires.",
        subscription:
          "« Abonnement » – signifie une période pendant laquelle vous utilisez le WebApp dans son ensemble ou certains contenus supplémentaires moyennant un tarif.",
        user_generated_content:
          "« Contenu Généré par les Utilisateurs » – signifie toute forme de Contenu, y compris, entre autres, les données, les textes, les images, les vidéos, les sons, les liens, qui ont été publiés par des utilisateurs sur des plateformes en ligne, par exemple, des réseaux sociaux (par exemple, Instagram, Facebook).",
        you: "« Vous » – désigne un individu utilisant le WebApp.",
      },
    },
    changes_of_eula: {
      title: "2. MODIFICATIONS DU CLUF",
      list: {
        changes_intro:
          "Nous pouvons apporter des modifications à ce CLUF de temps à autre. Vous devez vérifier régulièrement la dernière version du CLUF au lien disponible sur la page web.",
        changes_effective:
          "Si vous n'êtes pas d'accord avec les termes du CLUF mis à jour, vous ne pouvez pas utiliser le WebApp à partir du jour où le CLUF mis à jour entre en vigueur. Dans ce cas, vous ne devez pas utiliser le WebApp et annuler le renouvellement de vos Abonnements.",
      },
    },
    device: {
      title: "3. APPAREIL",
      list: {
        use_non_owned_device:
          "Si vous avez l'intention d'utiliser le WebApp sur un Appareil que vous ne possédez pas, vous devez avoir la permission du propriétaire pour le faire. Vous serez responsable du respect de ce CLUF, que vous possédiez ou non l'Appareil.",
        access_to_non_owned_device:
          "Si vous ne possédez pas l'Appareil, vous êtes autorisé à utiliser le WebApp uniquement via votre Compte.",
        responsibility:
          "Si vous utilisez l'Appareil avec d'autres personnes, assurez-vous que personne d'autre que vous ne peut utiliser le WebApp depuis votre Compte. Toutes les actions effectuées dans votre Compte sont considérées comme vos actions, peu importe qui effectue réellement ces actions. Vous êtes entièrement responsable de toutes les actions effectuées dans votre Compte.",
        removal:
          "Si vous décidez de vendre ou autrement de vous débarrasser de l'Appareil, vous devez supprimer le WebApp de l'Appareil.",
      },
    },
    capacity_and_age: {
      title: "4. CAPACITÉ JURIDIQUE ET ÂGE",
      list: {
        over_16:
          "Le WebApp est conçu pour les utilisateurs de plus de 16 ans. Si vous utilisez le WebApp, vous confirmez que vous avez au moins 16 ans et que vous avez la capacité juridique complète pour conclure l'Accord.",
        between_16_18:
          "Si vous avez entre 16 et 18 ans, votre parent, tuteur ou autre représentant légal doit vérifier et accepter ce CLUF en votre nom. Si vous utilisez le WebApp, vous confirmez que votre parent, tuteur ou autre représentant légal a accepté les termes de ce CLUF et vous autorise à utiliser le WebApp.",
      },
    },
    intellectual_property: {
      title: "5. PROPRIÉTÉ INTELLECTUELLE",
      list: {
        license_grant_and_webapp_use_terms:
          "Nous vous accordons par la présente une licence non exclusive, personnelle, limitée, révocable et non transférable pour accéder, télécharger et exécuter le WebApp uniquement sur votre Appareil, à condition que vous acceptiez de respecter tous les termes et conditions de ce CLUF. Veuillez noter que le WebApp est licencié, et non vendu, à vous.",
        intellectual_property_rights_and_reservation_of_rights:
          "La Société ou le concédant de licence de la Société est le seul titulaire des Droits de Propriété Intellectuelle concernant le WebApp. La Société conserve tous les droits, titres et intérêts relatifs au WebApp et se réserve tous les droits non expressément accordés à vous dans ce CLUF.",
        restrictions_on_transferring_rights_to_webapp:
          "Vous ne pouvez pas vendre, revendre, distribuer, redistribuer, louer, sous-louer, céder, copier ou transférer d'une autre manière des droits sur le WebApp à des tiers.",
        restrictions_on_network_distribution_and_access:
          "Vous ne pouvez pas distribuer ou rendre le WebApp disponible sur un réseau où il pourrait être téléchargé ou utilisé par plusieurs utilisateurs simultanément, sauf si cela est expressément autorisé par nous.",
        prohibitions_on_interfering_with_webapp_functionality:
          "Vous ne pouvez pas utiliser de dispositif ou de processus automatique ou manuel pour interférer avec le bon fonctionnement du WebApp. Cependant, vous pouvez utiliser tout type de dispositif ou de processus pour supprimer le WebApp de votre Appareil.",
        prohibitions_on_decompiling_and_reverse_engineering:
          "Vous ne pouvez pas décompiler, désassembler, rétro-ingénierie ou créer des œuvres dérivées du WebApp ou de ses parties. Toutes les modifications ou améliorations du WebApp restent la propriété exclusive de la Société.",
        prohibitions_on_unlawful_use_and_malicious_activity:
          "Vous ne pouvez pas utiliser le WebApp de manière illégale, à des fins illégales, ou de manière incompatible avec ce CLUF, ni agir de manière frauduleuse ou malveillante, par exemple, en piratant ou en insérant du code malveillant, tel que des virus, ou des données nuisibles, dans le WebApp.",
      },
    },
    subscription_and_trial_period: {
      title: "6. ABONNEMENT ET PÉRIODE D'ESSAI",
      list: {
        subscription_basis_and_fee_variation:
          "Ce WebApp dans son ensemble ou une partie de celui-ci (Contenu supplémentaire) est fourni sur une base d'abonnement payant. Les frais peuvent varier en fonction de la durée de l'Abonnement.",
        automatic_renewal_and_account_charge:
          "L'Abonnement se renouvellera automatiquement pour la même période à la fin de l'Abonnement au coût du forfait choisi. Votre Compte sera facturé pour l'Abonnement renouvelé dans les 24 heures précédant la fin de l'Abonnement actuel.",
        cancellation_of_subscription_renewal:
          "Vous pouvez annuler le renouvellement de l'Abonnement au moins 24 heures avant la fin de l'Abonnement : dans ce cas, le WebApp dans son ensemble ou son Contenu supplémentaire sera disponible jusqu'à la fin de l'Abonnement. Pour annuler le renouvellement automatique de l'Abonnement, veuillez modifier les paramètres d'abonnement de votre Compte. Après la fin de l'Abonnement, le WebApp dans son ensemble ou son Contenu supplémentaire sera disponible uniquement si un nouvel Abonnement est acheté.",
        manual_cancellation_required:
          "Votre abonnement ne s'arrêtera pas automatiquement. Vous devez annuler le renouvellement automatique de votre abonnement pour ne pas être facturé du coût du nouvel Abonnement.",
        free_trial_period_and_auto_conversion:
          "Le WebApp offre une période d'essai gratuite de 7 jours. Vous pouvez utiliser le WebApp ou son Contenu supplémentaire gratuitement pendant cette période. Veuillez noter qu'à la fin de la période d'essai, elle sera automatiquement convertie en un Abonnement payant pour la période la plus courte disponible et votre Compte sera facturé pour le coût de cet Abonnement, sauf si vous annulez l'Abonnement via les paramètres d'abonnement de votre Compte au moins 24 heures avant la fin de la période d'essai gratuite.",
      },
    },
    fees_and_purchase_terms: {
      title: "7. FRAIS ET CONDITIONS D'ACHAT",
      list: {
        subscription_costs_availability:
          "Les coûts de tous les Abonnements sont disponibles sur la page Web.",
        payment_processing_by_platform_administrator:
          "Lorsque vous achetez un Abonnement, l'Administrateur de la Plateforme facture votre Compte et collecte l'argent en notre nom. Le paiement est traité par un système de traitement des paiements mis en place par l'Administrateur de la Plateforme.",
        no_access_to_payment_information:
          "Veuillez noter que nous ne traitons pas votre paiement et n'avons pas accès à vos informations de paiement, telles que, entre autres, les données de votre carte bancaire, votre nom ou toute autre information connexe.",
        questions_on_payment_processing:
          "Si vous avez des questions concernant le traitement des paiements, veuillez soumettre votre problème au service de support utilisateur de l'Administrateur de la Plateforme.",
        account_charge_timing:
          "Votre Compte est facturé du coût du nouvel Abonnement dans les 24 heures précédant la fin de l'Abonnement actuel. Si vous annulez le renouvellement automatique dans les dernières 24 heures de l'Abonnement, cette annulation prendra effet à la fin du nouvel Abonnement.",
        no_refunds_and_immediate_content_access:
          "Veuillez noter que nous ne procédons pas à des remboursements. Le contenu numérique est mis à votre disposition immédiatement après que les frais d'Abonnement ont été facturés à votre Compte.",
      },
    },
    user_generated_content: {
      title: "8. CONTENU GÉNÉRÉ PAR LES UTILISATEURS",
      list: {
        exposure_to_objectionable_content:
          "Étant donné que vous pouvez accéder aux publications d'autres utilisateurs d'Instagram, vous pouvez être exposé à du contenu généré par les utilisateurs potentiellement répréhensible. Veuillez prendre en compte que la Société ne contrôle ni ne pré-vérifie aucun contenu généré par les utilisateurs publié sur les réseaux sociaux.",
        modifications_and_censorship:
          "Tout type de modification ou de censure par la Société concernant le contenu généré par les utilisateurs peut être considéré comme une violation des droits humains ou des droits d'auteur et peut potentiellement vous induire en erreur.",
        handling_objectionable_content:
          "Si vous avez été exposé à tout type de contenu répréhensible, vous pouvez utiliser les fonctionnalités du réseau social concerné pour suivre et supprimer le contenu généré par les utilisateurs répréhensible.",
        company_disclaimer:
          "En aucun cas la Société ne pourra être tenue responsable de tout contenu généré par les utilisateurs.",
      },
    },
    disclaimer: {
      title: "9. AVIS DE NON-RESPONSABILITÉ",
      list: {
        general_disclaimer_of_warranties:
          "Dans toute la mesure permise par la loi applicable, nous et nos affiliés, dirigeants, employés, agents, partenaires et concédants de licence déclinons expressément toutes garanties de toute nature, expresse ou implicite, quant à l'exactitude, l'adéquation ou l'exhaustivité des informations contenues dans notre WebApp ou créées par les services.",
        content_provided_as_is:
          "Le Contenu de notre WebApp est fourni sur une base « telle quelle », sans aucune garantie de commercialisation ou d'adéquation à un but ou usage particulier. Nous ne garantissons pas que vous obtiendrez un résultat attendu de l'utilisation de la WebApp.",
        no_warranty_on_specifics: {
          title: "Nous ne garantissons pas que :",
          a: "la WebApp répondra à vos exigences ;",
          b: "la WebApp sera exempte d'erreurs, sécurisée ou ininterrompue ;",
          c: "les erreurs de fonctionnalité de la WebApp seront corrigées ;",
          d: "la qualité de la WebApp sera à la hauteur de vos attentes.",
        },
        limitation_of_liability:
          "Nous n'avons aucune responsabilité pour les erreurs ou omissions. Nous ne sommes pas responsables des dommages, qu'ils soient directs ou indirects, spéciaux ou conséquents, subis par vous ou par toute autre personne en raison de l'utilisation de la WebApp, même si vous avez été informé de la possibilité de tels dommages. Aucun conseil ou information, qu'ils soient oraux ou écrits, obtenus de notre part ou de notre WebApp ne créera une garantie non expressément indiquée dans le CLA. En aucun cas notre responsabilité ou celle de nos affiliés, en vertu de toute cause d'action, que ce soit en vertu d'un contrat, en responsabilité délictuelle ou autre, ne dépassera le montant payé par vous pour l'accès à la WebApp. De plus, nous n'aurons aucune responsabilité pour les retards ou échecs dus à des circonstances échappant à notre contrôle.",
      },
    },
    transfer_of_rights: {
      title: "10. TRANSFERT DES DROITS",
      list: {
        transfer_by_company:
          "Nous pouvons transférer nos droits et obligations en vertu de cette EULA à toute autre organisation ou personne sans votre consentement. Nous vous informerons toujours par écrit si cela se produit et nous veillerons à ce que le transfert n'affecte pas vos droits en vertu de l'EULA.",
        transfer_by_user:
          "Vous ne pouvez transférer vos droits ou obligations en vertu de cette EULA à une autre personne que si nous y consentons par écrit.",
      },
    },
    termination_of_rights: {
      title: "11. RÉSILIATION DES DROITS",
      list: {
        termination_for_breach:
          "Nous pouvons mettre fin à vos droits d'utilisation de l'application Web à tout moment en vous contactant si vous avez violé les règles de cette EULA de manière grave. Si ce que vous avez fait peut être corrigé, nous vous donnerons une opportunité raisonnable pour le faire.",
        actions_upon_termination: {
          title:
            "Si nous mettons fin à vos droits d'utilisation de l'application Web :",
          a: "Vous devez arrêter toutes les activités autorisées par cette EULA, y compris votre utilisation de l'application Web.",
          b: "Vous devez supprimer ou retirer l'application Web de tous les appareils et détruire immédiatement toutes les copies de l'application Web que vous possédez et nous confirmer que vous avez fait cela.",
        },
      },
    },
    miscellaneous: {
      title: "12. DIVERS",
      list: {
        separation_of_paragraphs:
          "Chacun des paragraphes de cette EULA fonctionne séparément. Si un tribunal ou une autorité compétente décide que l'un d'eux est illégal, les paragraphes restants demeureront en vigueur et effectifs.",
        delay_in_enforcement:
          "Même si nous retardons l'application de cette EULA, nous pouvons toujours l'appliquer plus tard. Si nous ne demandons pas immédiatement que vous fassiez ce que vous êtes tenu de faire en vertu des termes de cette EULA, ou si nous retardons la prise de mesures contre vous en raison de la violation de l'EULA, cela ne signifie pas que vous n'avez pas à faire ces choses et cela ne nous empêchera pas de prendre des mesures contre vous ultérieurement.",
        governing_law:
          "Cette EULA sera régie et interprétée conformément aux lois de Dublin, Irlande, sans égard à ses dispositions sur les conflits de lois.",
        dispute_resolution:
          "En cas de conflit, de controverse ou de différend entre vous et la Société, il sera réglé à l'amiable par des négociations. Si un tel conflit, controverse ou différend ne peut être résolu à l'amiable par des négociations dans un délai de trente (30) jours, il sera réglé par l'Association d'Arbitrage d'Irlande conformément à ses procédures accélérées internationales.",
        number_of_arbitrators: "Le nombre d'arbitres sera un.",
        place_of_arbitrators: "Le lieu de l'arbitrage sera Dublin, Irlande.",
        language_of_arbitrators:
          "L'arbitrage se déroulera et la sentence sera rendue en anglais.",
        expense:
          "Chaque partie (c'est-à-dire vous et la Société) supportera ses propres frais, mais les parties partageront également les frais du tribunal d'arbitrage.",
        support:
          "Support. Si vous souhaitez en savoir plus sur l'application Web ou si vous rencontrez des problèmes pour l'utiliser, veuillez nous contacter à <tag>support@freelanz.app</tag>",
      },
    },
  },
  privacy_policy: {
    title: "Politique de Confidentialité",
    commitment_title: "Notre Engagement envers Votre Confidentialité",
    commitment_text:
      "Nous respectons et protégeons la confidentialité de nos utilisateurs de la WebApp. Cette Politique de Confidentialité explique comment nous recueillons et utilisons vos informations et fait partie de nos Conditions d'Utilisation lorsque vous utilisez notre WebApp. En utilisant notre WebApp et le service fourni via la WebApp (« Service »), vous consentez à notre Politique de Confidentialité. Si vous n'êtes pas d'accord, veuillez ne pas utiliser notre WebApp.",
    info_collection_title: "Quelles informations collectons-nous ?",
    info_collection_text:
      "Si vous effectuez des achats ou achetez un abonnement, nos prestataires de services de facturation tiers collecteront des informations telles que votre nom complet, le numéro de votre carte de crédit et l'adresse de facturation. Si vous nous envoyez un e-mail, nous pourrions utiliser votre adresse e-mail pour répondre à votre e-mail. Informations envoyées par votre appareil mobile. Nous collectons certaines informations que votre appareil mobile envoie lorsque vous utilisez notre WebApp, telles qu'un identifiant d'appareil, les paramètres utilisateur et le système d'exploitation de votre appareil, ainsi que des informations sur votre utilisation de nos Services. Informations sur la localisation. Lorsque vous utilisez notre WebApp, nous pouvons collecter et stocker des informations sur votre localisation en convertissant votre adresse IP en une géolocalisation approximative ou en accédant aux coordonnées GPS de votre appareil mobile ou à une localisation approximative si vous activez les services de localisation sur votre appareil. Nous pouvons utiliser les informations de localisation pour améliorer et personnaliser nos Services pour vous. Si vous ne souhaitez pas que nous collectons des informations de localisation, vous pouvez désactiver cette fonctionnalité sur votre appareil mobile.",
    info_storage_title: "Où stockons-nous vos informations ?",
    info_storage_text:
      "Vos informations peuvent être stockées sur nos propres serveurs ou sur des serveurs appartenant à des fournisseurs de stockage en nuage tiers. Les fournisseurs de stockage tiers ne peuvent utiliser vos informations que comme prévu dans cette Politique de Confidentialité.",
    info_usage_title: "Comment utilisons-nous vos informations ?",
    info_usage_text:
      "Les informations que nous collectons auprès de vous pourraient être utilisées :",
    info_storage_duration_title:
      "Combien de temps stockons-nous vos informations ?",
    info_storage_duration_text:
      "Nous avons l'intention de stocker certaines de vos informations indéfiniment. Et les liens vers d'autres sites web ? Nous pouvons fournir des liens vers ou une compatibilité avec d'autres sites web. Cependant, nous ne sommes pas responsables des pratiques de confidentialité employées par ces sites web ou des informations ou contenus qu'ils contiennent.",
    info_protection_title: "Comment protégeons-nous vos informations ?",
    info_protection_text:
      "Nous utilisons des procédures physiques, électroniques et autres appropriées pour protéger et sécuriser les informations que nous collectons. Cependant, veuillez être conscient que l'Internet est un environnement intrinsèquement non sécurisé, et que les pirates travaillent constamment pour contourner les mesures de sécurité. Par conséquent, nous ne pouvons garantir que vos informations ne seront pas accessibles, divulguées, modifiées ou détruites, et vous acceptez ce risque.",
    user_protection_title: "Comment pouvez-vous protéger vos informations ?",
    user_protection_text:
      "Nous vous encourageons à prendre des mesures pour garder vos informations personnelles en sécurité en ne les partageant pas avec d'autres personnes ou en les publiant en ligne.",
    disclosure_title: "Divulguons-nous des informations à des tiers ?",
    disclosure_text:
      "Nous ne collectons, ne vendons, ne commerçons ni ne transférons autrement vos Informations Personnelles Identifiables (PII) à des tiers à des fins commerciales ou marketing, sauf comme indiqué dans cette Politique de Confidentialité. Les informations personnelles (et non personnelles) collectées via le Site peuvent être partagées avec des entreprises et des organisations qui effectuent des services en notre nom (par exemple, des entreprises qui fournissent des services de gestion de données ou d'autres services de soutien tels que le stockage de données et les services d'hébergement Web). Nous pouvons partager vos informations personnelles (et non personnelles) avec des tiers pour vous fournir des publicités pertinentes et promouvoir nos produits, mais nous ne vendrons pas vos informations personnelles. Informations divulguées dans le cadre de transactions commerciales. Si nous sommes acquis par un tiers à la suite d'une transaction telle qu'une fusion, une acquisition ou une vente d'actifs ou si nos actifs sont acquis par un tiers en cas de faillite ou de fermeture de notre entreprise, certains ou tous nos actifs, y compris vos PII, peuvent être divulgués ou transférés à un acquéreur tiers dans le cadre de la transaction. Informations divulguées pour notre protection et celle des autres. Nous coopérons avec les autorités gouvernementales et les forces de l'ordre ou les parties privées pour faire respecter et se conformer à la loi. Nous pouvons divulguer toute information vous concernant aux autorités gouvernementales ou aux forces de l'ordre ou aux parties privées comme nous le croyons, à notre entière discrétion, nécessaire ou approprié : (i) pour répondre aux réclamations, aux procédures légales (y compris les convocations) ; (ii) pour protéger nos biens, droits et sécurité et les biens, droits et sécurité d'un tiers ou du public en général ; et (iii) pour stopper toute activité que nous considérons comme illégale, contraire à l'éthique ou juridiquement actionnable.",
    not_for_children_title: "Non destiné aux enfants",
    not_for_children_text:
      "Notre WebApp et Service ne sont pas destinés aux enfants de moins de 16 ans. Nous ne recueillons ni ne collectons sciemment des informations auprès ou sur des enfants de moins de 16 ans.",
    policy_changes_title: "Modifications de notre Politique de Confidentialité",
    policy_changes_text:
      "Si nous décidons de modifier notre Politique de Confidentialité, nous publierons ces changements sur cette page. Nous pouvons également, mais ne sommes pas tenus de, vous envoyer un avis par e-mail. Nous vous encourageons à consulter fréquemment cette politique de confidentialité pour être informé de la manière dont nous protégeons vos informations.",
    contact_title: "Contactez-nous",
    contact_text:
      "Si vous avez des questions concernant notre Politique de Confidentialité, veuillez nous contacter à <tag>support@freelanz.app</tag>",
  },
};

export const screens_fr_Translation = {
  common_text: {
    male: "Homme",
    female: "Femme",
    terms_and_conditions: "Conditions Générales",
    privacy_policy: "Politique de Confidentialité",
    copy_right: "Droits d'auteur ® 2024. Tous droits réservés.",
    continue: "Continuer",
    login_text: "SE CONNECTER",
  },
  landing_page: {
    title: "Cours d'IA Personnalisés",
    personalized_freelance_plan: "Créez votre chemin vers la liberté",
    start_freelance_business:
      "Démarrez une Activité de Freelance : <tag/>Devenez Votre Propre Patron",
    launch_successful_business:
      "Lancez Votre Entreprise de Freelance avec Succès Dès Aujourd'hui",
    select_text: "Sélectionnez votre sexe :",
  },
  career_plan: {
    title: "Plan de liberté de carrière selon votre âge",
    age_18_24: "18-24",
    age_25_34: "25-34",
    age_35_44: "35-44",
    age_45_plus: "45+",
  },
  community: {
    title: "36 000 $",
    sub_title: "pourrait être là où commence votre aventure en freelance",
  },
  goal_selection: {
    question: "Quel est votre objectif ?",
    priority: "Veuillez sélectionner votre première priorité",
    grow_wealth: "Accroître la richesse",
    be_boss: "Être mon propre patron",
    travel_more: "Voyager davantage",
    other: "Autre",
  },
  income_source: {
    question: "Quelle est votre source de revenu actuelle ?",
    job: "Emploi de 9h à 17h",
    freelance: "Freelance",
    other: "Autre",
  },
  income_level: {
    question: "Choisissez votre niveau de revenu actuel",
    low: "Faible",
    medium: "Moyen",
    high: "Élevé",
  },
  financial_situation: {
    question: "Comment décririez-vous votre situation financière ?",
    struggling: "J'ai du mal à atteindre mes objectifs financiers",
    stability: "Je voudrais avoir plus de stabilité",
    unsure: "Je ne suis pas sûr(e)",
    comfortable: "Je suis à l'aise",
    range_30_50k: "30 000 $ - 50 000 $",
    range_50_100k: "50 000 $ - 100 000 $",
    range_above_100k: "Plus de 100 000 $",
  },
  remote_work: {
    question:
      "Appréciez-vous la flexibilité du travail à distance dans votre carrière ?",
    yes: "Oui",
    maybe: "Peut-être",
    no: "Non",
  },
  work_family_balance: {
    question:
      "Avez-vous du mal à <tag/> équilibrer le travail et le temps familial ?",
    absolutely: "Absolument",
    somewhat: "Un peu",
    work_life_balance: "J'ai un équilibre travail-vie personnelle",
    prefer_not_to_say: "Préférer ne pas répondre",
  },
  work_situation: {
    question: "Quel type de situation professionnelle aspirez-vous à avoir ?",
    remote_balance: "Équilibre en télétravail",
    stable_routine: "Routine stable",
    exploring_options: "J’explore les options",
  },
  travel_while_working: {
    question: "Souhaitez-vous pouvoir voyager tout en travaillant ?",
    dream: "C'est un rêve",
    traveling: "Je voyage",
    sometimes: "Parfois",
    not_priority: "Pas une priorité",
  },
  content_writing_knowledge: {
    question: "Évaluez vos connaissances en rédaction de contenu",
    upwork_info:
      "Selon Upwork, un rédacteur de contenu freelance gagne environ 42 000 $ par an",
    need_more_info: "J'ai besoin de plus d'informations",
    know_everything: "Je sais tout",
  },
  ai_content_creation: {
    question:
      "Saviez-vous que les outils d'IA peuvent rendre la création de contenu encore plus facile ?",
    no_news: "Non, c'est une nouvelle pour moi",
    curious: "Je suis curieux(se)",
    heard_of_it: "Oui, j'en ai entendu parler",
  },
  digital_marketing_knowledge: {
    question: "Évaluez vos connaissances en marketing numérique",
    upwork_info:
      "Selon Upwork, un spécialiste en marketing numérique gagne environ 100 000 $ par an.",
    need_more_info: "J'ai besoin de plus d'informations",
    know_everything: "Je sais tout",
  },
  promote_business_ability: {
    question: "Évaluez votre capacité à <tag/> promouvoir des affaires",
    upwork_info:
      "70 % des freelances trouvent leur travail en ligne, et vous le pouvez aussi.",
    need_more_info: "J'ai besoin de plus d'informations",
    know_everything: "Je sais tout",
  },
  ai_promotion_help: {
    question:
      "Saviez-vous que les outils d'IA peuvent vous aider avec la promotion ?",
    no_news: "Non, c'est une nouvelle pour moi",
    curious: "Je suis curieux(se)",
    heard_of_it: "Oui, j'en ai entendu parler",
  },
  job_interests: {
    question: "Choisissez les emplois qui pourraient vous intéresser",
    digital_marketing: "Marketing Numérique",
    smm: "SMM",
    affiliate_marketing: "Marketing d'Affiliation",
    dropshipping: "Dropshipping",
    content_writing: "Rédaction de Contenu",
    copywriting: "Rédaction",
    translation: "Traduction",
    graphic_design: "Design Graphique",
    blogging: "Blogging",
    illustration: "Illustration",
    continue: "Continuer",
  },
  freelancing_readiness: {
    question: "Évaluez votre préparation à commencer le freelancing",
    need_more_info: "J'ai besoin de plus d'informations",
    know_everything: "Je sais tout",
  },
  freelance_platforms: {
    question: "Plateformes de freelancing dont vous avez entendu parler",
    freelancer: "Freelancer",
    linkedin: "LinkedIn",
    fiverr: "Fiverr",
    guru: "Guru",
    toptal: "Toptal",
    upwork: "Upwork",
    designhill: "Designhill",
    flexjobs: "Flexjobs",
    behance: "Behance",
    wwr: "WWR",
  },
  summary_screen: {
    title: "Résumé de votre <line/> <tag>profil de freelance</tag>",
    readiness_score: "Score de Préparation",
    result_perfect: "Résultat : Parfait",
    required_score: "Requis - 75",
    impressive_score: "Score impressionnant pour réussir en freelance",
    description:
      "Les freelances bénéficient d'une plus grande flexibilité et d'un potentiel de gains accru, 61 % d'entre eux gagnant plus que dans les emplois traditionnels. Vous pouvez également profiter du freelancing.",
    mindset: "ÉTAT D'ESPRIT",
    entrepreneur: "Entrepreneur",
    motivation: "MOTIVATION",
    high: "Élevé",
    time_for_freelancing: "TEMPS",
    for_freelancing: "Pour le freelancing",
    knowledge: "CONNAISSANCES",
    beginner: "Débutant",
  },
  special_achievement: {
    question: "Y a-t-il quelque chose de spécial que vous souhaitez réaliser ?",
    options: {
      buy_house: "Acheter une maison",
      perfect_wedding: "Un mariage parfait",
      vacation: "Vacances",
      buy_car: "Acheter une nouvelle voiture",
      retirement: "Retraite sans souci",
    },
    continue: "Continuer",
  },
  time_to_goal: {
    question:
      "Combien de temps êtes-vous prêt(e) à consacrer pour atteindre votre objectif ?",
    options: {
      five_min: "5 min/jour",
      ten_min: "10 min/jour",
      fifteen_min: "15 min/jour",
      twenty_min: "20 min/jour",
    },
  },
  personal_plan: {
    title: "Votre plan personnel pour la liberté de carrière",
    based_on_answers:
      "En fonction de vos réponses, nous prévoyons que vous acquérez les compétences nécessaires en freelance d'ici",
    confident_freelancer_by: "Freelance confiant(e) d'ici {{month}}, {{year}}",
    confident: "Confiant(e)",
    freelancer: "Freelance",
    beginner: "Débutant(e)",
  },
  designing_plan: {
    title: "Nous concevons votre plan de liberté de carrière…",
    people_chosen: "Plus de 70 000 personnes",
    chosen_freelanz_app: "ont choisi Freelanz.app",
    exploring_financial_freedom: "Explorer la Liberté Financière",
    essential_guide: "Guide Essentiel",
    great_discovery: "Grande Découverte",
  },
  testimonials: {
    sean: {
      name: "Sean",
      text: "FreeLanz favorise la liberté financière grâce au travail freelance. L'interface simplifiée et les opportunités variées en font une ressource précieuse pour les nouveaux freelances comme moi.",
    },
    angel: {
      name: "Angel",
      text: "Je suis ravi de mon parcours d'apprentissage avec FreeLanz, où une large gamme de sujets freelances est explorée dans leurs cours. La rédaction publicitaire est ce que je préfère.",
    },
    trisha: {
      name: "Trisha",
      text: "FreeLanz m'a inspirée à poursuivre des connaissances en technologie et en IA, me poussant à surmonter mon anxiété et viser des sommets !",
    },
  },
  email_signup: {
    title:
      "Entrez votre email pour obtenir votre plan personnel de <tag>Liberté de Carrière</tag> !",
    privacy_note:
      "Nous respectons votre vie privée. Votre email peut rendre l'expérience publicitaire plus pertinente <tag> Politique de Confidentialité </tag>.",
    email_label: "Votre Email",
    email_placeholder: "Entrez une adresse email valide",
    success_message: "Bien joué !",
  },
  login: {
    title: "Se Connecter",
    description:
      "Entrez votre adresse email enregistrée pour accéder à l'application",
    email_label: "Votre email",
    email_placeholder: "Entrez une adresse email valide",
    login_button: "Se Connecter",
    no_account: "Pas encore de compte ? <tag>Inscrivez-vous</tag>",
  },
  career_plan_ready: {
    title: "Votre Plan de Liberté de Carrière de 4 semaines est prêt !",
    readiness_level: "Votre niveau de préparation",
    after_4_weeks: "Après 4 semaines",
    now: "Maintenant",
    week_labels: {
      week_1: "Semaine 1",
      week_2: "Semaine 2",
      week_3: "Semaine 3",
      week_4: "Semaine 4",
    },
  },
  otp: {
    title: "Entrez le OTP",
    message:
      "Un mot de passe à usage unique a été envoyé à votre <tag/> Email : {{email}}",
    submit_button: "Soumettre",
    resend_otp: "Renvoyer le OTP",
  },
  payment: {
    email: "email",
    email_placeholder: "Entrez une adresse email valide",
    card_number: "NUMÉRO DE CARTE",
    expires_on: "EXPIRATION LE",
    process_card: "Traitement de la Carte",
    discount_expires: "La remise expire dans",
    try_now: "ESSAYEZ MAINTENANT",
    min: "Min",
    sec: "Sec",
    now: "Maintenant",
    goal: "Objectif",
    flexibility: "Flexibilité",
    earning_power: "Pouvoir d'achat",
    limited: "Limité",
    high: "Élevé",
    basic: "De base",
    disclaimer: "Ceci n'est pas une garantie ou une promesse de résultats.",
    trial_offer:
      "Essayez <tag>FreeLanz 7 jours pour $1</tag>, et vous bénéficierez de :",
    // trial_offer: "Essayez <tag>Freelanz 4 Weeks</tag> et vous :",
    benefits: {
      ai_tools: "Maîtrisez les outils d'IA qui peuvent augmenter vos revenus",
      additional_sources: "Découvrez des sources de revenus supplémentaires",
      skills:
        "Acquérez les compétences d'un Pro Freelance et lancez vos revenus",
      beginner_lessons: "Accès à des leçons adaptées aux débutants",
      guidance: "Conseils pour la compétence et le succès en freelancing",
    },
    trial: "Essai de 7 jours",
    // trial: "PLAN DE 4 SEMAINES",
    payment_methods: "Carte de Crédit <tag>/</tag> Débit",
    guaranteed_checkout: "Paiement <tag>Sécurisé</tag> Garanti",
    what_you_get: "Ce que vous obtenez",
    income_know_how: "Connaissances en revenu freelance",
    lessons: "Leçons perspicaces, faciles et amusantes",
    personal_coach:
      "Chat 24/7 avec votre coach personnel pour obtenir toutes les réponses et réduire les erreurs",
    users_love: "Les utilisateurs adorent nos plans",
    user_reviews: {
      review_1:
        "J'apprécie vraiment les leçons que vous fournissez sur divers sujets. Je suis déterminé à exceller dans ce domaine, et j'ai acquis des connaissances précieuses. Cela a été une expérience enrichissante et j'ai absorbé une richesse de savoirs.",
      review_2:
        "Je dois reconnaître que ce cours est parmi les meilleurs que j'ai jamais suivis. Il fournit des aperçus pratiques dans le domaine du marketing digital.",
      review_3:
        "Ces cours ont été extrêmement bénéfiques. Je n'ai jamais rencontré une application qui offre des informations aussi complètes que Coursiv. L'aspect remarquable est que j'apprends constamment de nouvelles stratégies et tactiques pour me promouvoir en ligne.",
    },
    career_titles: {
      digital_marketing: "Marketing Digital",
      content_writer: "Rédacteur de Contenu",
      graphic_designer: "Graphiste",
    },
    career_info: {
      digital_marketing: "$100,000 par an",
      content_writer: "$42,000 par an",
      graphic_designer: "$90,000 par an",
    },
    no_degree: "Pas besoin d'être un professionnel",
    no_university_degree: "Pas besoin de diplôme universitaire",
    work_at_your_pace:
      "Travaillez à votre propre rythme et selon vos conditions",
    people_often_ask: "Les gens demandent souvent",
    faqs: {
      career_freedom_plan:
        "En quoi consiste le Plan de Liberté de Carrière et comment puis-je commencer ?",
      commitment_concerns:
        "Je suis inquiet de m'engager dans le freelancing puis d'abandonner en cours de route.",
      technical_skills:
        "Est-il possible d'apprendre le freelancing sans compétences techniques spécialisées ?",
    },
    faq_answers: {
      career_freedom_plan:
        "FreeLanz offre à quiconque la possibilité de se lancer dans le freelancing en fournissant des matériaux d'apprentissage accessibles. Le Plan de Liberté de Carrière se concentre sur l'enseignement des compétences essentielles en freelance dans un format convivial et ludique, abordant des concepts potentiellement complexes de manière facilement compréhensible.",
      commitment_concerns:
        "Nous comprenons vos inquiétudes, c'est pourquoi FreeLanz assure une expérience adaptée aux débutants. Notre mentor IA est disponible pour fournir des conseils tout au long de votre parcours, nécessitant peu d'effort de votre part.",
      technical_skills:
        "Absolument ! Nos ressources d'apprentissage sont conçues pour simplifier les sujets techniques, les rendant accessibles à tous. Bien que posséder des antécédents techniques puisse être bénéfique, ce n'est pas un prérequis pour réussir en freelancing.",
    },
    money_back_guarantee: "Garantie de Remboursement de 100%",
    guarantee_message:
      "Nous croyons que notre plan peut fonctionner pour vous et que vous obtiendrez des résultats en 4 semaines ! Nous sommes même prêts à vous rembourser si vous ne voyez pas de résultats, mais cela dépend principalement de vous. Veuillez vérifier notre <tag>Politique de Remboursement</tag> pour comprendre toutes les exigences.",
  },
};
